import React from "react";
import styles from "./AllergenDetails.module.css";
import { useNavigate } from "react-router-dom";
import { SubmitButton, TextComponent } from "../../../../../components";
import { List } from "antd";
import { FaRegCheckCircle } from "react-icons/fa";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import HeadingComponent from "../../../../../components/HeadingComponent/HeadingComponent";

const AllergenDetails = () => {
  const navigate = useNavigate();

  const Data = [
    {
      id: 1,
      name: "Mixing",
      price: "$35",
      type: "License Packs",
      Features: ["Sanitize work surface  license", "Sanitize work surface"],
    },
    {
      id: 2,
      name: "Assembly",
      price: "$5",
      type: "Staff License",
      Features: ["Sanitize work surface  license", "Sanitize work surface"],
    },
    {
      id: 3,
      name: "PROOF/CHILL",
      price: "$35",
      type: "License Packs",
      Features: ["Sanitize work surface  license", "Sanitize work surface"],
    },
    {
      id: 4,
      name: "OVEN",
      price: "$35",
      type: "License Packs",
      Features: ["Sanitize work surface  license", "Sanitize work surface"],
    },
    {
      id: 5,
      name: "PACKAGING",
      price: "$35",
      type: "License Packs",
      Features: ["Sanitize work surface  license", "Sanitize work surface"],
    },
    {
      id: 6,
      name: "MAKE UP",
      price: "$35",
      type: "License Packs",
      Features: ["Sanitize work surface  license", "Sanitize work surface"],
    },
  ];

  const renderItem = (item, index) => {
    return (
      <div className={styles.AO_listItem}>
        <div className={styles.row}>
          <div>
            <TextComponent
              text={item?.name}
              padding={"0px"}
              className={styles.Name}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.CardSubList}>
            {item?.Features?.map((element, index) => {
              return (
                <div className={styles.list} key={index}>
                  <TextComponent text={element} className={styles.ItemText} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Peanut"}
        showBackIcon={true}
        showControlButtons={true}
      />

      <div className={styles.subCont}>
        <HeadingComponent text={"Concerned Stations"} fontSize={24} />
        <div className={styles.ActiveOrderDiv}>
          <List
            dataSource={Data}
            renderItem={renderItem}
            style={{ width: "100%" }}
            grid={{
              gutter: [16, 24],
              xs: 1,
              sm: 1,
              md: 1,
              lg: 1,
              xl: 2,
              xxl: 2,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AllergenDetails;
